import Link from '@/components/link';
import ArrowSVG from '@/svg/icons/arrow.svg';

export default function EnterpriseCard() {
  return (
    <div className="relative h-full overflow-hidden rounded-lg bg-deep-sea shadow-image transition-all duration-300 ease-in-out hover:shadow-card-hover">
      <Link
        href="/contact"
        className="block h-full w-full px-4 pb-9 pt-12 md:px-9 md:pt-16"
      >
        <div className="relative z-10 flex h-full flex-col">
          <h3 className="mb-6 max-w-[380px] text-xl font-bold leading-tight text-white md:text-[38px]">
            Lets talk about your{` `}
            <b className="block font-bold text-bunting-sea md:inline">
              ambitious ideas
            </b>
          </h3>
          <p className="max-w-[555px] text-sm leading-normal text-gray-300 md:text-xl">
            From video-on-demand platforms to academic databases, GraphCMS
            powers some of the most innovative projects out there. Let’s talk
            about how we can work together on yours.
          </p>

          <p className="mt-6 flex items-center text-sm font-medium text-gray-300 md:mt-auto md:text-base">
            <span>Speak with an Expert</span>
            <ArrowSVG className="ml-2 h-5 w-5 rotate-180 transform fill-current" />
          </p>
        </div>

        <svg
          viewBox="0 0 277 466"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute top-0 right-0 z-0 h-[98px] w-[58px] md:h-[466px] md:w-[277px]"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M220.985 62.05L165.74 93.077 110.495 124.1l-55.25 31.027v186.155l55.25-31.028 55.245-31.027v-62.05l-55.245 31.027v-62.05l55.245-31.027 55.245-31.027v186.154l-55.245 31.028-55.245 31.022-55.25 31.028L0 434.354l55.245 31.028 55.25-31.028 55.245-31.022 55.245-31.028 55.249-31.022V31.027L220.985 0v62.05z"
            fill="#11173B"
          />
        </svg>
      </Link>
    </div>
  );
}
